/* eslint-disable react/jsx-no-literals */
import React, { ReactNode } from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';
import Icon from 'carbon-react/lib/components/icon';
import { IconType } from 'carbon-react/lib/components/icon';

import * as styles from './highlight-metric-card.scss';

type BorderColor = 'positive' | 'warning' | 'negative';

const BORDER_COLORS: Record<BorderColor, string> = {
  positive: '#00815D',
  warning: '#BA8B00',
  negative: '#C7384F'
};

const ICON_BG_COLORS: Record<BorderColor, string> = {
  positive: '#E6F5F0',
  warning: '#FFF4CC',
  negative: '#FBDDE2'
};

interface HighlightMetricCardProps {
  icon: IconType;
  label: string;
  value: string;
  description: ReactNode;
  color: BorderColor;
}

const HighlightMetricCard = ({ icon, label, value, description, color }: HighlightMetricCardProps) => {
  return (
    <div className={styles.card} style={{ borderLeftColor: BORDER_COLORS[color] }}>
      <div className={styles.iconWrapper} style={{ backgroundColor: ICON_BG_COLORS[color] }}>
        <Icon type={icon} color={BORDER_COLORS[color]} />
      </div>
      <Typography fontSize="12px" fontWeight="400" lineHeight="140%" mb={1} color="var(--colorsUtilityYin055)">
        {label}
      </Typography>
      <Typography fontSize="32px" fontWeight="900" lineHeight="120%" mb={1}>
        {value}
      </Typography>
      <Typography fontSize="13px" fontWeight="400" lineHeight="150%" mb={0} color="var(--colorsUtilityYin065)">
        {description}
      </Typography>
    </div>
  );
};

interface HighlightMetricCardsProps {
  metrics: HighlightMetricCardProps[];
}

export const HighlightMetricCards = ({ metrics }: HighlightMetricCardsProps) => {
  return (
    <Box display="flex" justifyContent="space-between" gap="24px">
      {metrics.map(metric => (
        <HighlightMetricCard key={metric.label} {...metric} />
      ))}
    </Box>
  );
};
